import { graphql } from "api/cms-website/generated";

export const ReferralHeroFragment = graphql(/* GraphQL */ `
    fragment ReferralHeroFragment on ComponentComponentsReferralHero {
        id
        noMarginBottom
        referralHeroTitle: title
        referralHeroSubtitle: subtitle
        referralHeroDescription: description
        referralHeroCard: card {
            title
            text
            bgColor
            textColor
            image {
                url
                width
                height
                alternativeText
            }
        }
    }
`);
